import appGlobalScript from '/home/runner/work/revogrid/revogrid/src/global/global.ts';
export const globalScripts = appGlobalScript;
